import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "@/components/Layout";
import ProjectsPage from "@/pages/ProjectsPage";
import ProjectDetailPage from "@/pages/ProjectDetailPage";
import ComparisonPage from "@/pages/ComparisonPage";
import MarketStudyPage from "@/pages/MarketStudyPage";
import PublicQuotePage from "@/pages/PublicQuotePage";

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <Routes>
                    <Route element={<Layout />}>
                        <Route path="/" element={<ProjectsPage />} />
                        <Route
                            path="/chantiers/:id"
                            element={<ProjectDetailPage />}
                        />
                        <Route
                            path="/chantiers/:id/comparaison"
                            element={<ComparisonPage />}
                        />
                        <Route
                            path="/etude-de-marche"
                            element={<MarketStudyPage />}
                        />
                    </Route>
                    <Route
                        path="/public/devis/:token"
                        element={<PublicQuotePage />}
                    />
                    <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
            </BrowserRouter>
            <Toaster
                position="top-right"
                toastOptions={{
                    className: "!font-sans !rounded-none !border !border-ink",
                }}
            />
        </div>
    );
}

export default App;
